<ng-template #loader>
    <shared-loader-for-spinner [inverted]="inverted" [thickness]="thickness" [color]="color"
        class="order-summary__loader">
    </shared-loader-for-spinner>
</ng-template>

<div class="order-summary" directive-max-on-screen-height="item" [registerId]="maxOnScreenHeight || null"
    [subRegisterId]="maxOnScreenHeight ? maxOnScreenHeight + '-summary' : null">
    <div class="order-summary__inner">

        <ul class="order-summary__list">
            <li class="order-summary__li -for-voucher" *ngIf="voucher">
                <span class="order-summary__label">
                    <div *ngIf="!(hasActiveVoucher$ | async)">You have saved</div>
                    <shared-hints-popup *ngIf="hasActiveVoucher$ | async" class="order-summary__hint--voucher"
                        [icon]="'You have saved'" [shouldBeVisibleOnInit]="true" [boldText]="true" [position]="'bottom'"
                        [type]="'success'">
                        {{voucher.VoucherName}}
                    </shared-hints-popup>
                </span>
                <span class="order-summary__value">
                    <ng-container *ngIf="loading">
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        {{voucher?.ActivatedOrderDiscount?.AmountApplied | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
                    </ng-container>
                </span>
            </li>

            <li class="order-summary__li -for-sub">
                <span class="order-summary__label">Subtotal</span>
                <span class="order-summary__value">
                    <ng-container *ngIf="loading">
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        {{summary?.Subtotal | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
                    </ng-container>
                </span>
            </li>
            <li class="order-summary__li -for-tax">
                <span class="order-summary__label">Tax</span>
                <span class="order-summary__value">
                    <ng-container *ngIf="loading">
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        {{summary?.Tax | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
                    </ng-container>
                </span>
            </li>

            <ng-container *ngFor="let surcharge of summary?.Surcharges">
                <li class="order-summary__li -for-surcharge" *ngIf="surcharge.IsVisibleForCustomer">
                    <span class="order-summary__label">
                        {{surcharge.CustomerFriendlyName}}
                        <shared-hints-popup class="order-summary__hint">
                            {{surcharge.CustomerFriendlyDescription}}
                        </shared-hints-popup>
                    </span>
                    <span class="order-summary__value">
                        <ng-container *ngIf="loading">
                            <ng-container *ngTemplateOutlet="loader"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="!loading">
                            {{(surcharge?.Value || 0) | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
                        </ng-container>
                    </span>
                </li>
            </ng-container>

            <li class="order-summary__li -for-total">
                <span class="order-summary__label">Total</span>
                <span class="order-summary__value">
                    <ng-container *ngIf="loading">
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        {{summary?.Total | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
                    </ng-container>
                </span>
            </li>
            <!-- REQUIRED TO RE-ANALYZE TOLO-1522 -->
            <!-- <li class="order-summary__li -for-total -for-paid" *ngIf="paidWith">
                <span class="order-summary__label">Paid with</span>
                <span class="order-summary__value">
                    <ng-container *ngIf="loading">
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        {{paidWith}}
                    </ng-container>
                </span>
            </li> -->
        </ul>

    </div>
</div>
